import { percentage } from 'Data/format.js'

export function getText(job) {
  return `Updating payment methods: ${percentage(
    Math.round(
      ((job.number_of_successful_tokens + job.number_of_failed_tokens) /
        job.total_number_of_tokens) *
        100
    )
  )} completed`
}
